import { Injectable } from '@angular/core'

import IconImport from './../icon/icon-import'
import { SportIcon } from './sport-icon'

@Injectable({providedIn: 'root'})
export class SportIconService {

  public sportBallIcons: SportIcon[]

  constructor() {
    // noop
  }

  public initSportIcons(): void {

    const allIcons = IconImport.getDictionary()
    const result = []

    for (const iconKey in allIcons) {
      if (iconKey.indexOf('se-ui-icon-sport-') !== -1) {
        result.push({
          iconKey: iconKey,
          name: iconKey.replace('se-ui-icon-sport-', '').replace(/-/g, ' ')
        })
      }
    }

    this.sportBallIcons = result

  }

  public getIconKeyBySportName(name: string): string {

    const other = 'sport-other'

    if (!name) {
      return other
    }

    if (!this.sportBallIcons || this.sportBallIcons.length === 0) {
      this.initSportIcons()
    }

    if (name.indexOf('-') !== -1) {
      name = name.replace(/-/g, ' ')
    }

    for (const icon of this.sportBallIcons) {
      if (icon.name.toLowerCase() === name.toLowerCase()) {
        return icon.iconKey
      }
    }

    return other

  }

}
